import { Group, Text } from '@mantine/core'

interface SectionTitleProps {
  title: string
}

const SectionTitle = ({ title }: SectionTitleProps) => (
  <Group justify='center'>
    <Text size='xs' tt='uppercase' fz={10} style={{ color: '#a1a1a1' }}>
      {title}
    </Text>
    <hr
      style={{
        flex: 1,
        color: '#a1a1a1',
        height: 1,
        border: 'none',
        backgroundColor: '#a1a1a1',
      }}
    />
  </Group>
)

export default SectionTitle
